export enum LanguageType {
  English = 'en',
  Spanish = 'es',
  German = 'de',
  Russian = 'ru'
}
